import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from '../shared/network/interceptors/auth.interceptor';
import { MainInterceptor } from '../shared/network/interceptors/main.interceptor';
import { ErrorHandlerInterceptor } from '../shared/network/interceptors/error-handler.interceptor';
import { SharedModule } from '../shared/shared.module';
import { AddExperienceComponent } from './add-experience/add-experience.component';
import { AddImageAltComponent } from './add-image-alt/add-image-alt.component';

import { ExperiencesRoutingModule } from './experiences-routing.module';
import { ExperiencesLogComponent } from './experiences-log/experiences-log.component';
import { AgmCoreModule } from '@agm/core';
import { ViewExperienceComponent } from './modals/view-experience/view-experience.component';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { ExperienceScheduleComponent } from './experience-schedule/experience-schedule.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgbModalModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ExperienceCalendarFilterComponent } from './experience-schedule/experience-calendar-filter/experience-calendar-filter.component';
import { ImageUploadModule } from 'angular2-image-upload';
import { AddExperienceDayComponent } from './add-experience/add-experience-day/add-experience-day.component';
import { AddExperiencePriceComponent } from './add-experience/add-experience-price/add-experience-price.component';
import { AddExperienceActivityComponent } from './add-experience/add-experience-activity/add-experience-activity.component';
import { ManageDayModalComponent } from './experience-schedule/manage-day-modal/manage-day-modal.component';
import { ExperienceBasicInfoComponent } from './add-experience/experience-basic-info/experience-basic-info.component';
import { ScheduleCreationComponent } from './add-experience/schedule-creation/schedule-creation.component';
import { ExperienceLocationComponent } from './add-experience/experience-location/experience-location.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AddOnlineExperienceComponent } from './add-online-experience/add-online-experience.component';
import {
  OnlineExperienceBasicInfoComponent
} from './add-online-experience/online-experience-basic-info/online-experience-basic-info.component';
import { OnlineExperienceScheduleComponent } from './add-online-experience/online-experience-schedule/online-experience-schedule.component';
import { OnlineExperienceLocationComponent } from './add-online-experience/online-experience-location/online-experience-location.component';
import { AddCancellationPolicyComponent } from './add-experience/add-cancellation-policy/add-cancellation-policy.component';
import { AssignLocalComponent } from './add-online-experience/assign-local/assign-local.component';
import { NgToggleModule } from '@nth-cloud/ng-toggle';

import { DropdownModule } from 'primeng/dropdown';
@NgModule({
  declarations: [
    AddExperienceComponent,
    AddImageAltComponent,
    ExperiencesLogComponent,
    ViewExperienceComponent,
    ExperienceScheduleComponent,
    ExperienceCalendarFilterComponent,
    AddExperienceDayComponent,
    AddExperiencePriceComponent,
    AddExperienceActivityComponent,
    ManageDayModalComponent,
    ExperienceBasicInfoComponent,
    ScheduleCreationComponent,
    ExperienceLocationComponent,
    AddOnlineExperienceComponent,
    OnlineExperienceBasicInfoComponent,
    OnlineExperienceScheduleComponent,
    OnlineExperienceLocationComponent,
    AddCancellationPolicyComponent,
    AssignLocalComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    SharedModule,
    ExperiencesRoutingModule,
    SelectDropDownModule,
    HttpClientModule,
    NgToggleModule,
    NgMultiSelectDropDownModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBxSEF3Pkhg-mU97PSbLAVNgvMLOJhmBeU',
      libraries: ['places']
    }),
    FullCalendarModule,
    NgbModalModule,
    NgbDropdownModule,
    DropdownModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    ImageUploadModule.forRoot()
  ],
  exports: [],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MainInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true
    }
  ]
})
export class ExperiencesModule {}
